<template>
    <div class="famous-pehl-item">
        <div class="famous-pehl-title">更新时间：{{source.updateTime}}</div>
        <div class="famous-pehl-content">贡献者：{{source.editorName}}</div>
        <div class="famous-pehl-content dsp-flex">
            <div class="famous-pehlc-title">修改原因：</div>
            <div class="famous-pehlc-content">{{source.editInfo}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FamousEditHistoryItem',
    props: {
        source: {
            type: Object,
            default() { return {} }
        }
    }
}
</script>